// blog — en. BlogNews page copy.

export default {
  blogEyebrow: 'Insights & Updates',
  blogTitleA: 'Blogs',
  blogTitleB: '& News',
  blogHeroDesc: 'Stay ahead with the latest insights on business growth, digital marketing, e-commerce, and company updates — curated for Ethiopian entrepreneurs and brands.',
  blogTabBlog: 'Blog',
  blogTabNews: 'News',
  blogSearchPlaceholder: 'Search articles...',
  blogSortNewest: 'Newest',
  blogSortOldest: 'Oldest',
  blogEmptyTitle: 'No articles found',
  blogEmptyDesc: 'Try a different search or category.',
  blogFeaturedTitle: 'Featured Articles',
  blogMoreTitle: 'More Articles',
  blogCategoriesTitle: 'Categories',
  blogReadMore: 'Read More',
  blogSourceRef: 'Source Reference ↗',
};